export default class CardGrid {
    
    static get selector() {
        return '.cardGrid';
    }

    constructor(el) {
        this.el = el;
        this.list = this.el.querySelector('.cardGrid__list');
        this.moreButton = this.el.querySelector('.cardGrid__more');

        this.hasMore = this.el.classList.contains('cardGrid--hasMore');
        this.currentPage = parseInt(this.el.dataset.currentPage);
        this.maxPage = parseInt(this.el.dataset.maxPage);
        this.nonce = this.el.dataset.nonce;
        this.isLoading = false;

        this.cards = this.getCards();
        this.query = this.getQuery();
        if(this.hasMore){
            this.resize();
        }
        //this.fillHole();
        this.setEvents();
    }

    getCards() {
        return Array.from(this.el.querySelectorAll('.card')).map(this.getCard);
    }

    getCard(el) {
//        let card = new Card(el); 

        return {
            //el : el,
            rect : el.getBoundingClientRect()
        };
    }

    getQuery() {
        let url = new URLSearchParams(window.location.search);
        let category = this.el.dataset.category;
        
        let query = {  postype : category  };
        if(url.getAll('cities[]').length) query.city = url.getAll('cities[]');
        if(url.get('orderby')) query.orderby = url.getAll('orderby');
        if(url.getAll('writers[]').length) query.writer = url.getAll('writers[]');
        return query;
    }

    getElemNodes(nodeList) {
        nodeList.forEach(node => {
            if (node.nodeType !== Node.ELEMENT_NODE) node.parentNode.removeChild(node);
        });
        return nodeList;
    }

    htmlstringToNS( html ) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        let nodelist = this.getElemNodes(doc.body.childNodes);
        return nodelist;
    }

    setOffset() {
        this.maxRight = Math.max(...this.cards.map( card => { return card.rect.right }));
        let rightCards = this.cards.filter(card => card.rect.right === this.maxRight);
        this.maxBottom = Math.max(...rightCards.map( card => { return card.rect.bottom }));
    }

    loadMore() {
        if(this.isLoading) return;
        this.activeLoader();


        const   form = new FormData();
                form.append('action', 'load_more');
                form.append('query', JSON.stringify(this.query));
                form.append('page', this.currentPage += 1);
                form.append('nonce', this.nonce);

        const params = new URLSearchParams(form);

        fetch(ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: params
        })
        .then((response) => {
            return response.text()
        })
        .then((html) => {
            this.list.insertAdjacentHTML( 'beforeend', html );

            /*
            let elements = this.htmlstringToNS(html);
            console.log(elements);

            Array.from(elements).forEach( element => {
                this.list.appendChild(element);
            });*/

            window.VegOut.parts.setup(this.el);

            window.dispatchEvent( new CustomEvent('inview-reload') );
            if(this.currentPage >= this.maxPage) {
                this.removeLoadMore();
            }
            else{
                this.cards = this.getCards();
                this.resize();
            }
            this.desactiveLoader();
        })
        .catch((err) => {
            console.log('Failed to fetch page: ', err);
            this.desactiveLoader();
            this.removeLoadMore();
        });
    }

    resize() {
        this.setOffset();

        let maxBottom = this.maxBottom - this.el.getBoundingClientRect().top - 50;
        this.list.style.maxHeight = maxBottom + 'px';
        this.list.style.overflow = 'hidden';
    }

    activeLoader() {
        this.isLoading = true;
        this.el.classList.add('cardGrid--loading');
    }

    desactiveLoader() {
        setTimeout( () => {
            this.el.classList.remove('cardGrid--loading');
            this.isLoading = false;
        }, 200);
    }

    removeLoadMore() {
        this.hasMore = false;
        this.list.style.maxHeight = '';
        this.el.classList.remove('cardGrid--hasMore');
        //this.list.style.overflow = '';
    }

    setEvents() {
        window.addEventListener('resize', this.e_resize.bind(this) );
        this.moreButton.addEventListener('click', this.e_clickMore.bind(this) );
    }

    e_resize() {
        this.resize();
    }

    e_clickMore(e) {
        e.preventDefault();
        console.log(e.target);
        e.target.blur();
        this.loadMore();
    }





    /*
    fillHole() {
        let continues = true;
        while (continues) {
            continues = this.addSquare();
        }
        window.dispatchEvent( new CustomEvent('inview-reload') );
    }

    removeSquare() {
        let square = document.getElementsByClassName('square');

        while (square[0]) {
            square[0].parentNode.removeChild(square[0]);
        };
    }

    addSquare() {
        //this.removeSquare();

        let square = document.createElement("div");
            square.classList.add('square');
            square.classList.add('js-in-view');
            square.classList.add('appear-fadeup');

        this.list.appendChild(square);

        let rect = square.getBoundingClientRect();

        if(rect.bottom <= this.maxBottom ){
            return true;
        }
        else{
            square.remove();
            return false;
        }
    }
    */

}